import SpotCurrentConditionsSection from './SpotCurrentConditionsSection';

export default SpotCurrentConditionsSection;
